import { render, staticRenderFns } from "./create-evaluated.component.html?vue&type=template&id=3d6b0b0b&scoped=true&"
import script from "./create-evaluated.component.ts?vue&type=script&lang=ts&"
export * from "./create-evaluated.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-evaluated.component.scss?vue&type=style&index=0&id=3d6b0b0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b0b0b",
  null
  
)

export default component.exports